import { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("/auth/users")
      .then((res) => {
        setUsers(res.data.users);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to fetch users");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="py-20 sm:py-24 px-4 sm:px-6 md:px-10 flex justify-center items-center min-h-[60vh]">
        <div className="text-xl sm:text-2xl text-slate-500 font-medium">Loading...</div>
      </div>
    );
  }

  return (
    <div className="py-20 sm:py-24 px-4 sm:px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-center mb-6 sm:mb-8 gap-3">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800">All Users</h1>
          <Link to="/questions-list">
            <button className="text-emerald-600 underline decoration-emerald-200 hover:decoration-emerald-500 hover:text-emerald-700 font-medium transition-colors text-sm sm:text-base">
              Back to Questions
            </button>
          </Link>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl shadow-xl overflow-hidden">
          <table className="min-w-full divide-y divide-slate-100">
            <thead>
              <tr className="bg-emerald-50/80">
                <th className="px-6 py-4 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">#</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Name</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Email</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Role</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-slate-700 uppercase tracking-wider">Total Answers</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {users.map((user, idx) => (
                <tr key={user._id} className="hover:bg-emerald-50/40 transition-colors">
                  <td className="px-6 py-4 text-sm text-slate-800 font-medium">{idx + 1}</td>
                  <td className="px-6 py-4">
                    <div className="flex items-center">
                      {user.picture && (
                        <img className="h-9 w-9 rounded-full mr-3 ring-2 ring-emerald-100" src={user.picture} alt={user.name} />
                      )}
                      <div className="text-sm font-medium text-slate-800">{user.name}</div>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600">{user.email}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2.5 py-0.5 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      user.role === "admin" ? "bg-purple-100 text-purple-800" : "bg-emerald-100 text-emerald-800"
                    }`}>
                      {user.role}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600">{Object.keys(user.answers || {}).length}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-3">
          {users.map((user, idx) => (
            <div key={user._id} className="bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl p-4 shadow-md">
              <div className="flex items-center gap-3 mb-3">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-emerald-100 text-emerald-700 text-xs font-bold flex-shrink-0">{idx + 1}</span>
                {user.picture && (
                  <img className="h-10 w-10 rounded-full ring-2 ring-emerald-100 flex-shrink-0" src={user.picture} alt={user.name} />
                )}
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-slate-800 truncate">{user.name}</p>
                  <p className="text-xs text-slate-500 truncate">{user.email}</p>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className={`px-2.5 py-0.5 text-xs font-semibold rounded-full ${
                  user.role === "admin" ? "bg-purple-100 text-purple-800" : "bg-emerald-100 text-emerald-800"
                }`}>
                  {user.role}
                </span>
                <span className="text-xs text-slate-500">{Object.keys(user.answers || {}).length} answers</span>
              </div>
            </div>
          ))}
        </div>

        {users.length === 0 && (
          <div className="text-center py-10 text-slate-500 bg-white/80 backdrop-blur-2xl border border-white/40 rounded-2xl shadow-xl">
            No users found
          </div>
        )}
      </div>
    </div>
  );
};

export default UsersList;
